import {useQuery} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';
import {PlayerTrainingResponse} from './types';

// GET /players/<username>/training/ -- IsAuthenticated + owner-only (the
// caller should only mount this for `is_owner === true`; a non-owner request
// still 403s server-side regardless).
export const useGetPlayerTrainingApi = (username?: string) =>
  useQuery(
    ['playerTraining', username],
    async (): Promise<PlayerTrainingResponse> =>
      (await ChessRestClient.get(`/players/${username}/training/`)).data,
    {enabled: !!username},
  );

export default useGetPlayerTrainingApi;
